// LUMINA · pages/vajra/admin/OverviewSection.jsx
// Phase 39D: extracted from AdminHub.jsx — admin overview (stats + recent activity)

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, DG, PANEL } from '../constants';
import { fmt } from '../utils';

export default function OverviewSection({ token, headers }) {
  const [overview, setOverview] = useState(null);

  const load = useCallback(async () => {
    const ov = await fetch(`${API}/vajra/staff/overview`, { headers })
      .then(r => r.ok ? r.json() : null)
      .catch(() => null);
    setOverview(ov);
  }, [token]);

  useEffect(() => { load(); }, [load]);

  if (!overview) return null;

  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:12,marginBottom:20}}>
        {[
          {label:"活跃师兄",value:overview.total_members,color:GD},
          {label:"本月新加入",value:overview.new_this_month,color:GD},
          {label:"今日已修行",value:overview.logged_today,color:DG},
          {label:"报名总人次",value:overview.total_registrations,color:"#555"},
        ].map(s=>(
          <div key={s.label} style={{background:PANEL,borderRadius:10,padding:"16px 18px",border:`1px solid rgba(0,0,0,0.06)`,textAlign:"center"}}>
            <div style={{fontSize:28,color:s.color,fontFamily:"'Inter',sans-serif"}}>{s.value}</div>
            <div style={{fontSize:11,color:"#aaa",marginTop:4,letterSpacing:.5}}>{s.label}</div>
          </div>
        ))}
      </div>
      {/* Recent activity */}
      <div style={{background:PANEL,borderRadius:12,padding:"18px 20px",border:`1px solid rgba(0,0,0,0.06)`}}>
        <div style={{fontSize:12,color:"#aaa",letterSpacing:1.5,textTransform:"uppercase",marginBottom:12}}>近期修行动态</div>
        {overview.recent_logs.length===0&&<div style={{fontSize:13,color:"#ccc",textAlign:"center",padding:"20px 0"}}>暂无记录</div>}
        {overview.recent_logs.map(l=>(
          <div key={l.id} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid rgba(0,0,0,0.04)",fontSize:13}}>
            <div>
              <span style={{color:GD,fontSize:12,marginRight:8}}>{l.member_name}</span>
              <span style={{color:"#555"}}>{l.practice_type}</span>
              {l.count>0&&<span style={{color:"#aaa",marginLeft:6,fontSize:12}}>{fmt(l.count)}遍</span>}
            </div>
            <span style={{color:"#ccc",fontSize:11}}>{l.logged_date}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
